import { NavLink } from "react-router-dom";
import { MessageCircle, Users, Kanban } from "lucide-react";

const tabs = [
  { path: "/m/chat", label: "Chat", icon: MessageCircle },
  { path: "/m/contatos", label: "Contatos", icon: Users },
  { path: "/m/crm", label: "CRM", icon: Kanban },
];

export const MobileTabBar = () => {
  return (
    <nav
      className="shrink-0 border-t border-border bg-card pb-[env(safe-area-inset-bottom)]"
      aria-label="Navegação principal"
    >
      <div className="mx-auto flex h-16 max-w-md items-stretch">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `flex flex-1 flex-col items-center justify-center gap-1 transition-colors duration-150 ${
                  isActive
                    ? "text-accent-blue"
                    : "text-muted-foreground active:text-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`flex h-8 w-14 items-center justify-center rounded-full transition-colors duration-150 ${
                      isActive ? "bg-accent-blue/10" : ""
                    }`}
                  >
                    <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.4 : 2} />
                  </span>
                  <span className={`text-[11px] leading-none ${isActive ? "font-semibold" : "font-medium"}`}>
                    {tab.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
